import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import { MaterialUnitInfo, MaterialUnitInfoInput } from '@/types/schemas';
import { formSchema, FormValues, initialValues } from '../schemas';
import { useSearchFieldStates } from './useSearchFieldStates';
import { FormMode } from '@/types/form';
import BasicInfo from './BasicInfo';

interface FormDialogProps {
  mode: FormMode;
  open: boolean;
  onClose: () => void;
  onSubmit: (data: MaterialUnitInfoInput) => void;
  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
  onWatchButtonClick?: () => void;

  initialData?: MaterialUnitInfo | null;
}
function FormDialog({
  mode,
  open,
  onClose,
  onAddButtonClick,
  onCopyButtonClick,
  onDeleteButtonClick,
  onEditButtonClick,
  onSubmit,
  initialData
}: FormDialogProps) {
  const searchFields = useSearchFieldStates(initialData);
  const handleSubmit = async (data: FormValues) => {
    await onSubmit({
      ...data,
      ma_vat_tu: searchFields.material?.uuid || '',
      ma_kho: searchFields.warehouse?.uuid || '',
      ma_vi_tri: searchFields.location?.uuid || ''
    });
  };
  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={mode === 'add' ? 'Mới' : mode === 'edit' ? 'Sửa' : 'Xem'}
        maxWidth='lg'
        disableBackdropClose={true}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={281} />}
      >
        <AritoFormV2
          mode={mode}
          hasAritoActionBar={false}
          schema={formSchema}
          onSubmit={handleSubmit}
          initialData={(initialData || initialValues) as FormValues}
          className='min-w-[600px]'
          headerFields={<BasicInfo mode={mode} searchFields={searchFields} />}
          bottomBar={
            <BottomActionBarV2
              mode={mode}
              onAdd={onAddButtonClick}
              onEdit={onEditButtonClick}
              onDelete={onDeleteButtonClick}
              onCopy={onCopyButtonClick}
              onSubmit={() => {}}
              onClose={onClose}
            />
          }
        />
      </DialogV2>
    </>
  );
}

export default FormDialog;
